<div class="site-page-header-ghost-wrapper">
    <nz-page-header class="site-page-header" nzBackIcon nzBack nzTitle="Programa" nzSubtitle=" - Lançamento de programas.">
    </nz-page-header>

    <form nz-form [formGroup]="programaForm" autocomplete="off" (ngSubmit)="onSubmitPrograma()" nzLayout="vertical">
        <div nz-row [nzGutter]="{ md: 24 }">
            <div nz-col nzSpan="15">
                <nz-form-item>
                    <nz-form-label nzRequired>Nome:</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Esse campo é obrigatório!">
                        <input nz-input name="nome" maxlength="45" formControlName="nome" placeholder="Nome do Programa" />
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzSpan="9">
                <nz-form-item>
                    <nz-form-label nzRequired>Autorizador:</nz-form-label>
                    <nz-form-control nzHasFeedback nzErrorTip="Esse campo é obrigatório!">
                        <nz-select name="idautorizador" formControlName="idautorizador" nzShowSearch nzPlaceHolder="Seleciona o Autorizador">
                            <nz-option *ngFor="let option of autorizadores" [nzLabel]="option.label" [nzValue]="option.value">
                            </nz-option>
                        </nz-select>
                    </nz-form-control>
                    <!--<span style="padding-top: 5px;"><a (click)="openCadAutorizador()">+ Cadastrar Autorizador</a></span>-->
                </nz-form-item>
            </div>

            <div nz-col nzSpan="10" nzOffset="7">
                <button nz-button nzType="primary" *ngIf="idprograma" nzBlock>Atualizar</button>
                <button nz-button nzType="primary" *ngIf="!idprograma" nzBlock>Cadastrar</button>
            </div>
        </div>
    </form>
</div>